import { useContext } from 'react'

import { CONTENT_TYPES } from '@scoir/college-content'
import { SectionTitle } from '@scoir/headers'

import ContentModalContext from '../../ContentModalProvider/Context'
import Section from '../../components/Section'
import { FIELD_NAMES, LABELS } from '../../components/constants'
import CardPreview from '../CardPreview'
import RegistrationLink from '../Type/RegistrationLink'
import AltText from './AltText'
import DateSelector from './DateTimeSelector'
import Description from './Description'
import ImageUpload from './ImageUpload'
import Recurrence from './Recurrence'
import Season from './Season'
import Title from './Title'
import VideoLink from './VideoLink'

const Details = () => {
  const { type } = useContext(ContentModalContext)

  return (
    <Section title="Preview">
      <CardPreview />
      <SectionTitle title="Details" />
      <Title />
      <ImageUpload />
      <AltText />
      {type !== CONTENT_TYPES.SESSIONS && <VideoLink />}
      {type === CONTENT_TYPES.SESSIONS && (
        <>
          <Recurrence />
          <DateSelector />
        </>
      )}
      {type === CONTENT_TYPES.PROGRAMS && <Season />}
      <Description />
      {type === CONTENT_TYPES.PROGRAMS && (
        <RegistrationLink
          label={LABELS.PROGRAM_WEBSITE}
          fieldName={FIELD_NAMES.LINK}
          helperText='This will appear as a "Learn More" button.'
        />
      )}
    </Section>
  )
}

export default Details
